<template>
  <div style="height:100%;overflow: scroll;">
    <div id="videos" v-loading="LOADING">
      <div class="col-12" style="margin-bottom: 4rem">
        <div class="row">
          <div class="col-12 col-lg-6 pb-2">
            <card id="order-med-card" class="mt-2" style="background-color: #cfe8f9;border-radius: 24px;" card-body-classes="pt-0" v-if="settings.patientWellness.yoga.practise.enabled" @click.native="$router.push('yogasets')">
              <h5 slot="header" class="card-title" style="font-weight: 600;color: #fff;filter: drop-shadow(2px 2px 3px grey);">
                {{ $t("message.Dedicated Training") }}
              </h5>
              <!-- <div class="pb-3" style="color: #fff;width: 16em;">
          Get medicine delivered at your doorsteps
        </div> -->

              <div slot="footer">
                <n-button round style="background: #fff; color: grey;font-weight: 600;border-radius: 0.8rem" size="lg" class="mb-2" @click.native="$router.push('yogasets')">
                  <i class="fa fa-running pr-1"></i>
                  {{ $t("message.Practise Now") }}
                </n-button>
              </div>
            </card>
          </div>

          <div class="col-12 col-lg-6 pb-2">
            <card id="consult-now-card" class="mt-2" style="background-color: #cfe8f9;border-radius: 24px" card-body-classes="pt-0" @click.native="scheduleAppointment" v-if="settings.patientWellness.yoga.liveTraining.enabled">
              <h5 slot="header" class="card-title" style="color: #fff;filter: drop-shadow(2px 2px 3px grey);font-weight: 600;">
                {{ $t("message.Live personalised training") }}
              </h5>

              <div slot="footer">
                <n-button round style="background: #fff; color: grey;font-weight: 600;border-radius: 0.8rem" size="lg" class="mb-2">
                  <img src="@/assets/img/meditate-icon.png" style="height: 1rem;filter: grayscale(1);opacity: 0.7;margin-top: -0.3rem;" />
                  {{ $t("message.Medidate") }}
                </n-button>
              </div>
            </card>
          </div>

          <div class="col-12 col-lg-6 pb-2">
            <card id="blog-card" class="mt-2" style="background-color: #cfe8f9;border-radius: 24px" card-body-classes="pt-0" @click.native="$router.push('/blogfeed?category=Yoga')" v-if="settings.patientWellness.yoga.blog.enabled">
              <h5 slot="header" class="card-title" style="color: #fff;filter: drop-shadow(2px 2px 3px grey);font-weight: 600;">
                {{ $t("message.Yoga Blog") }}
              </h5>
              <div class="pb-3" style="color: #fff;width: 20em;">
                {{ $t("message.Get inspired with yoga blogs") }}
              </div>

              <div slot="footer">
                <n-button round style="background: #fff; color: grey;font-weight: 600;border-radius: 0.8rem" size="lg" class="mb-2">
                  <i class="fas fa-book-reader pr-1"></i>
                  {{ $t("message.View Blog") }}
                </n-button>
              </div>
            </card>
          </div>

          <div class="col-12 col-lg-6 pb-2">
            <card id="videos-card" class="mt-2" style="background-color: #cfe8f9;border-radius: 24px" card-body-classes="pt-0" @click.native="goToVideos" v-if="settings.patientWellness.yoga.videos.enabled && caregroup">
              <h5 slot="header" class="card-title" style="color: #fff;filter: drop-shadow(2px 2px 3px grey);font-weight: 600;">
                {{ $t("message.Yoga Videos") }}
              </h5>
              <div class="pb-3" style="color: #fff;width: 20em;">
                {{ $t("message.Yoga videos, yoga routines and more") }}
              </div>

              <div slot="footer">
                <n-button round style="background: #fff; color: grey;font-weight: 600;border-radius: 0.8rem" size="lg" class="mb-2">
                  <i class="fas fa-play pr-1"></i>
                  {{ $t("message.Watch Videos") }}
                </n-button>
              </div>
            </card>
          </div>
        </div>
      </div>

      <n-button type="primary" round size="lg" style="font-weight: 600;position: fixed;bottom: 0px;left: 50%;transform: translate(-50%);" @click.native="$store.commit('setState', {
        stateName: 'trainingType',
        stateValue: 'yoga',
      }); $router.push('/fitnessandyogareports')">
        <i class="el-icon-tickets"></i>
        {{ $t("message.View Reports") }}
      </n-button>
    </div>
    <!--     <div class="col-12" style="text-align:center" v-show="!LOADING">
      <n-button type="primary" round size="lg" @click.native="$router.push('yogasets')" style="font-weight: 600">
        <i class="fa fa-running pr-1"></i>
        TRAIN
      </n-button>
    </div> -->
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  name: "videos",

  components: { Carousel, Slide },

  data() {
    return {
      LOADING: true,
      selectedVideo: null,
      playerVars: {
        autoplay: 1,
        modestbranding: 1,
      },
      carouselSlide: 0,
      caregroup: null
    };
  },

  async mounted() {
    this.$root.onBackButton = () => {
      this.$router.push("/patienthome");
    };
    let that = this;

    this.$store.commit("setState", {
      stateName: "trainingType",
      stateValue: "yoga",
    });

    try {
      let getCaregroups = await this.$store.dispatch("getCaregroups");
      for (let caregroup of getCaregroups.data) {
        if (caregroup.name == "Yoga") {
          this.caregroup = caregroup
          break;
        }
      }
    } catch (e) {
      console.log(e);
    }

    that.LOADING = false;
  },

  beforeDestroy() {
    this.$root.onBackButton = null;
  },

  watch: {
    carouselSlide: function () {
      if (this.$refs.youtubeVideos) {
        for (let video of this.$refs.youtubeVideos) {
          video.player.pauseVideo();
        }
      }
    },
  },

  computed: {
    user() {
      return JSON.parse(localStorage.user);
    },
    player() {
      return this.$refs.youtube.player;
    },
  },
  methods: {
    selectVideo(video) {
      this.selectedVideo = video;
      this.$forceUpdate();
    },
    scheduleAppointment() {
      this.$router.push("/trainerconsult?type=yoga");
    },
    goToVideos() {
      this.$store.commit('setState', {
        stateName: 'videos',
        stateValue: this.caregroup.videos
      })
      this.$router.push({ path: 'videos', query: { title: 'Yoga Videos' } })
    }
  },
};
</script>

<style scoped>
#consult-now-card {
  background-image: url("../../../assets/img/yoga1.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
  background-color: #cfe8f9;
  border-radius: 24px;
  height: 100%;
}

#order-med-card {
  background-image: url("../../../assets/img/yoga2.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
  background-color: #cfe8f9;
  border-radius: 24px;
  height: 100%;
}

#blog-card {
  background-image: url("../../../assets/img/blog.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
}

#videos-card {
  background-image: url("../../../assets/img/yoga.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
}

/deep/ iframe {
  width: 100%;
  height: 16em;
}

.video-thumbnail {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}

.playing-video-title {
  font-weight: 600;
  margin-top: 1rem;
}

.videos-list {
  overflow-y: scroll;
  height: 54vh;
}

/deep/.el-loading-spinner {
  position: fixed;
}

/deep/ .el-loading-mask {
  background: #fff !important;
}

@media (min-width: 992px) {
  iframe {
    height: 31em;
  }
}

@media (min-height: 736px) {
  /deep/ iframe {
    height: 35vh;
  }

  .videos-list {
    height: 40vh;
  }
}

@media (min-height: 768px) {
  /deep/ iframe {
    height: 40vh;
  }

  .videos-list {
    height: 40vh;
  }
}

@media (min-height: 1024px) {
  iframe {
    height: 31em;
  }

  .videos-list {
    height: 46vh;
  }
}

/deep/ .VueCarousel-dot-container {
  margin-top: 0px !important;
}

/deep/ .VueCarousel-dot {
  width: 5px !important;
  height: 5px !important;
  margin-top: 0px !important;
}

/deep/ .VueCarousel-dot:focus {
  outline: none !important;
}
</style>
